import React from "react";

interface ErrorMsgProps {
    errorMessage: string;
}

const ErrorMessage: React.FC<ErrorMsgProps> = (
    {
        errorMessage,

    }
) => {
    return (
        <p className="o-error-message">
            {errorMessage}
        </p>
    )
}

export default ErrorMessage;
